// 用户模块
export default {
    namespaced: true,
    state () {
      return {
        expertList:[]
      }
    },
    mutations: {
        // 修改用户信息
        setExpertList (state, payload) {
          state.expertList = payload
        },

        
    },
    actions:{
      // 获取用户信息
      getExpertList(context,payload){
        context.commit('setExpertList',payload)
      },
    },
    getters:{

    }
}